export function validatePassport(passport: string): boolean {

    if (passport.length > 5 && passport.length < 20) {
        return true;
    } else {
        return false;
    }
}
